const REFERRAL_COOKIE_NAME = "eccl_ref";
const REFERRAL_COOKIE_DAYS = 90;

function getCookie(name: string): string | null {
  const match = document.cookie.match(new RegExp("(^| )" + name + "=([^;]+)"));
  return match ? decodeURIComponent(match[2]) : null;
}

function setCookie(name: string, value: string, days: number) {
  const expires = new Date(Date.now() + days * 24 * 60 * 60 * 1000).toUTCString();
  document.cookie = `${name}=${encodeURIComponent(value)}; expires=${expires}; path=/; SameSite=Lax`;
}

/**
 * Lê o parâmetro ?ref= da URL atual e, se presente, grava num cookie de longa
 * duração para ser lido depois no cadastro (createChurch), mesmo que o
 * visitante navegue por várias páginas antes de se cadastrar.
 */
export function captureReferralCookie() {
  const params = new URLSearchParams(window.location.search);
  const ref = params.get("ref");
  if (ref?.trim()) {
    setCookie(REFERRAL_COOKIE_NAME, ref.trim(), REFERRAL_COOKIE_DAYS);
  }
}

export function getReferralCode(): string | null {
  return getCookie(REFERRAL_COOKIE_NAME);
}
